import Vue from 'vue/dist/vue.esm'

const eventBus = globalThis.eventBus || new Vue();
globalThis.eventBus = eventBus;

export default eventBus;
